module.exports = __webpack_public_path__ + "static/img/empty.6eb8dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/empty.png
// module id = 9Zg5
// module chunks = 1